<template>
  <div
    class="
      absolute
      top-0
      left-0
      w-full
      h-full
      bg-black
      z-20
      flex flex-col
      items-center
      justify-center
      p-8
    "
  >
    <ViceLoader />
  </div>
</template>

<script>
import ViceLoader from '@/Components/Loaders/ViceLoader.vue';

export default {
  name: 'SessionPausedNotification',
  components: {
    ViceLoader,
  },
};
</script>
